<template>
  <div :class="['financial-card', title === 'Crédito Consumido' ? 'financial-card__click' : '']">
    <span
      v-if="title === 'Crédito Consumido'"
      class="financial-card__tooltip"
    >
      Ver Extrato
    </span>
    <div class="financial-card__header">
      <p class="financial-card__header-title">
        {{ title }}
      </p>
      <p class="financial-card__header-subtitle">
        {{ subtitle }} <strong style="color: #818181;">{{ boldSubtitle }}</strong>
      </p>
    </div>
    <div class="financial-card__body">
      <p :class="['financial-card__body-value', textColorClass]">
        {{ isCurrency ? formattedValue : value }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "FinancialCard",
  props: {
    title: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
      required: true,
    },
    boldSubtitle: {
      type: String,
      required: true,
    },
    value: {
      type: [String, Number],
      required: true,
    },
    isCurrency: {
      type: Boolean,
      default: false,
    },
    textColorClass: {
      type: String,
      default: "financial-card__body-value--bordo",
    },
  },
  computed: {
    formattedValue() {
      if (this.isCurrency) {
        return new Intl.NumberFormat("pt-BR", {
          style: "currency",
          currency: "BRL",
        }).format(this.value);
      }
      return this.value;
    },
  },
};
</script>

<style lang="scss" scoped>
.financial-card {
  background-color: #ffffff;
  border-radius: 8px;
  padding: 16px;
  font-family: 'Exo 2', sans-serif !important;
  width: 225px;
  min-height: 110px;
  display: flex;
  flex-direction: column;
  position: relative;

  &__click {
    cursor: pointer;
    border: 2px solid transparent;
    transition: all 0.2s ease-in-out;

    &:hover {
      box-shadow: 0px 4px 4px 0px rgba(22, 22, 22, 0.2) ;
      border-color: #7F1A54
    }
  }

  &__tooltip {
    position: absolute;
    top: -30px;
    left: 50%;
    transform: translateX(-50%);
    background-color: #818181;
    padding: 10px;
    border-radius: 8px;
    white-space: nowrap;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.2);
    z-index: 10;
    opacity: 0;
    transition: opacity 0.2s ease-in-out;
    color: #ffffff;
    font-family: Exo 2;
    font-weight: 500;
    font-size: 13.33px;
    line-height: 100%;
    letter-spacing: 0px;


    &:after {
      content: '';
      position: absolute;
      top: 100%;
      left: 50%;
      transform: translateX(-50%);
      border-width: 5px;
      border-style: solid;
      border-color: #818181 transparent transparent transparent;
    }
  }

  &:hover .financial-card__tooltip {
    opacity: 1;
  }

  &__header {
    margin-bottom: 12px;
    margin-bottom: 12px;
    flex: 1;

    &-title {
      font-size: 16px;
      font-weight: bold;
      color: #818181;
    }

    &-subtitle {
      font-size: 12px;
      color: #999999;
    }
  }

  &__body {
    margin-top: 8px;

    &-value {
      font-size: 24px;
      font-weight: bold;

      &--bordo {
        color: #7F1A54;
      }

      &--green {
        color: #52CC9C;
      }

      &--red {
        color: #BF0000;
      }

      &--gray {
        color: #999999;
      }
    }
  }
}
</style>
